import type {
  AttendanceConceptDetail,
  AttendanceConceptItem,
  CreateAttendanceConceptResult,
  LC_AttendanceConceptDetailOut,
  LC_AttendanceConceptItemOut,
  LC_CreateAttendanceConceptOut,
  LC_SyncAttendanceConceptsOut,
  LC_UpdateAttendanceConceptOut,
  SyncAttendanceConceptsResult,
  UpdateAttendanceConceptResult,
} from '../types/attendanceConcept.types';


export function mapAttendanceConceptItem(
  raw: LC_AttendanceConceptItemOut,
): AttendanceConceptItem {
  return {
    id: raw.id,
    code: raw.code,
    name: raw.name,
    type: raw.type,
    calculationFormula: raw.calculationFormula,
    obtentionFormula: raw.obtentionFormula,
    handling: raw.handling,
  };
}

export function mapSyncAttendanceConcepts(
  raw: LC_SyncAttendanceConceptsOut,
): SyncAttendanceConceptsResult {
  return {
    created: raw.created,
    updated: raw.updated,
    total: raw.total,
    summary: raw.summary,
  };
}

export function mapAttendanceConceptDetail(
  raw: LC_AttendanceConceptDetailOut,
): AttendanceConceptDetail {
  return {
    id: raw.id,
    code: raw.code,
    name: raw.name,
    type: raw.type,
    calculationFormula: raw.calculationFormula,
    obtentionFormula: raw.obtentionFormula,
    handling: raw.handling,
    handlingId: raw.handlingId,
    calculationFormulaId: raw.calculationFormulaId,
    obtentionFormulaId: raw.obtentionFormulaId,
  };
}

export function mapUpdateAttendanceConceptResult(
  raw: LC_UpdateAttendanceConceptOut,
): UpdateAttendanceConceptResult {
  return {
    id: raw.id,
    handling: raw.handling,
    calculationFormula: raw.calculationFormula,
    obtentionFormula: raw.obtentionFormula,
  };
}

export function mapCreateAttendanceConceptResult(
  raw: LC_CreateAttendanceConceptOut,
): CreateAttendanceConceptResult {
  return {
    id: raw.id,
    name: raw.name,
    code: raw.code,
  };
}
